// Open AI API - common funcs - Conversation Model
//NOTE - This is not used yet
const retrievedAssistants = new Set<string>(); // ✅ Prevent redundant calls
const initializedAssistants = new Set<string>(); // ✅ Prevents redundant calls
//const retrievingAssistants = new Map<string, Promise<any>>(); // ✅ Prevents race conditions

const OPENAI_API_BASE_URL =  'https://api.openai.com/v1';


// ⛔ The two key reads here were DEAD and are removed (2026-08-14). `OPENAI_API_KEY_RIVER_ISLAND`
// and `CMW_NOVA_OPENAI_KEY` are not REACT_APP_-prefixed, so CRA never inlined them and this always
// returned undefined. Deleted rather than "fixed": ⛔ a browser bundle must never carry an OpenAI
// key or even the NAME of one — prefixing them would have shipped the secret to every visitor.
// This module is marked "not used yet" at the top and only `fetchPromptSession` is imported.
const getAPIKey = (): string | undefined => undefined;


const getAuthHeader = () => `Bearer ${getAPIKey()}`;
if (!getAPIKey) {
    alert("❌ Missing environment variable: OPENAI_API_KEY.\nPlease check your .env file and ensure it includes:\nOPENAI_API_KEY)");
}

export function chatAPI() {
// HTTP Chat Completions APIs
 const initializeHTTPSClient = async (endpoint: string, assistantId: string, selectedBot: any, setItems: any) => {

    if (initializedAssistants.has(assistantId)) {
            console.warn(`[chatAPI] HTTPS client already initialized for assistant ${assistantId}. Skipping.`);
            return;
        }

    initializedAssistants.add(assistantId); // ✅ Prevents duplicate initialization

    let httpEndpoint = endpoint.replace(/^wss:\/\//, 'https://');// normalize prefix from wss 
    console.log(`[chatAPI] Preparing HTTPS client for endpoint: ${endpoint} and assistantId: ${assistantId}`);

        try {
    
        const userMessage = 'Session Initialize';
        const response = await fetch(httpEndpoint, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            //Authorization: auth, //❌ Previously causing scope issues
            Authorization: getAuthHeader(), // ✅ Now dynamically retrieves authHeader
            },
            body: JSON.stringify({
            model: selectedBot.model,
            messages: [
                { role: 'system', content: 'You will use the uploaded files in your vector store for all file searches' },
                { role: 'assistant', content: "You are a conversation agent" },
                ...(userMessage ? [{ role: 'user', content: userMessage }] : []),
            ],
            temperature: 0.8
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP request failed. Status: ${response.status}`);
        }

        const responseData = await response.json();

        setItems((prevItems: any) => [...prevItems, { role: 'assistant', formatted: { text: responseData.choices[0].message.content } }]);

        } catch (error) {
        console.error('[chatAPI] Error initializing HTTPS client:', error);
        setItems((prevItems: any) => [
            ...prevItems,
            { role: 'system', formatted: { text: 'Failed to initialize conversation. Please try again later.' } },
        ]);
        }
};

    
const fetchHTTPResponse = async (assistantId: string, selectedBot: any, setItems: any) => {
    console.log(`[chatAPI] Fetching HTTP response for assistantId: ${assistantId}`);

    const inputElement = document.getElementById('user-input') as HTMLTextAreaElement;
    const userMessage = inputElement?.value.trim() || 'Start Chat Completion session';

    if (!userMessage) {
    console.warn('No message provided. Input is empty.');
    return;
    }

    // Clear input field
    inputElement.value = '';

    try {
    if (!assistantId) {
        console.warn('No matching bot found for assistantId:', assistantId);
        return;
    }

    setItems((prevItems: any) => [...prevItems, { role: 'user', formatted: { text: userMessage } }]);

    let httpEndpoint = selectedBot.endpoint.replace(/^wss:\/\//, 'https://');// normalize prefix from wss 

    const response = await fetch(httpEndpoint, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        Authorization: getAuthHeader(), // ✅ Dynamically retrieve authHeader
        },
        body: JSON.stringify({
        model: selectedBot.model,
        messages: [
            { role: 'system', content: 'You will use the uploaded files in your vector store for all file searches' },
            { role: 'assistant', content: selectedBot.instructions },
            { role: 'user', content: userMessage },
        ],
        tools: [{ type: 'file_search' }],
        }),
    });

    if (!response.ok) {
        throw new Error(`HTTP request failed. Status: ${response.status}`);
    }

    const responseData = await response.json();

    setItems((prevItems: any) => [...prevItems, { role: 'assistant', formatted: { text: responseData.choices[0].message.content } }]);

    } catch (error) {
    console.error('[chatAPI] Error fetching HTTP response:', error);
    }
};

return { fetchHTTPResponse, initializeHTTPSClient };


}
export const fetchPromptSession = async (promptId: string) => {
  const response = await fetch("https://api.openai.com/v1/realtime/sessions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: getAuthHeader(),
    },
    body: JSON.stringify({
      prompt: {
        id: promptId,
        version: "2",
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`❌ Failed to fetch session for promptId ${promptId} — Status ${response.status}`);
  }

  const sessionData = await response.json();

  // ✅ Realtime sessions return "id" (session id) and require building a ws endpoint
  return {
    assistantId: sessionData.id ?? null, // fallback to session id
    endpoint: `wss://api.openai.com/v1/realtime?session=${sessionData.id}`, // construct endpoint
    model: sessionData.model ?? null,
    voice: sessionData.voice ?? null,
    clientSecret: sessionData.client_secret?.value ?? null,
  };
};




